import { useEffect, useState } from "react";
import { BpmService } from "../../../../../core/services/BpmService";
import { useDashboardStore } from "../../../../pages/hooks/useDashboardStore";
import { CardTaps } from "../../../../theme/Component/CardTaps";

interface Props {
    ID: number;
}

export const CardTramitesHistory = ({ ID }: Props) => {

    const { setLoading } = useDashboardStore();
    const service = new BpmService();
    const [lista, setLista] = useState([]);

    useEffect(() => {
        getTramites()
    }, [ID])

    const getTramites = () => {
        setLoading(true);
        service.getProcedureActionByProcedureImp(ID).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setLoading(false);
            }
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="accordion accordion-flush">
                    <div className="activity-timeline" style={{ maxHeight: '600PX', overflowY: 'auto', minWidth: '350px' }}>
                        {lista.reverse().map((Historico: any, index: number) => {
                            const numero = lista.length - index;
                            return (
                                <div key={index} className="row m-3 border-bottom pb-1">
                                    <div className="col-md-2 d-flex align-items-center">
                                        <div className="circle-number">
                                            {numero}
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="row" >
                                            <div className="col-md-12"><small className="text-primary">{Historico.DataBeanProperties.VerifiedDate}</small> / <strong>{Historico.DataBeanProperties.ProcedureActionName}</strong></div>
                                            {/* <div className="col-md-12">Fecha de verificación: {Historico.DataBeanProperties.UptoDate}</div> */}
                                            <div className="col-md-12">Tipo de Proceso: {Historico.DataBeanProperties.DocumentTypeName}</div>
                                            <div className="col-md-12">Gestionado por: {Historico.DataBeanProperties.AccountName}</div>
                                            <div className="col-md-12">Estado: {Historico.DataBeanProperties.StateName}</div>

                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
